import React, { useEffect, useContext, useReducer } from "react";
import { dataFetchReducer } from "../../Utils/requestUtils";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment"
import ErrorBoundary from "../../Utils/ErrorBoundary";
import AuthContext from "../../../context/auth-context"
import WithdrawalCard from "./WithdrawalCard/WithdrawalCard"
import DecisionBox from "./DecisionBox/DecisionBox"
import AlertCard from "./AlertCard/AlertCard"
import ClientCard from "./ClientCard/ClientCard"
import TerminalCard from "./TerminalCard/TerminalCard"
import HistoricCard from "./HistoricCard/HistoricCard"
import NextTransaction from "../../Utils/NextTransaction/NextTransaction";

function Withdrawal(props){
    let history = useHistory()

    let roles = useContext(AuthContext).user_data.roles
    if (!roles.includes("read_withdrawals")){
        history.push("")
    }

    let { withdrawal_key } = useParams();

    const [withdrawal, dispatchWithdrawal] = useReducer(
        dataFetchReducer,
        {fetchedData: null, isLoading: true, isError: false} 
    )

    useEffect(() => {
		dispatchWithdrawal({type: "data_fetch_init"})
		const timer = setTimeout(() => {
			axios.get('/dash/withdrawal/withdrawal/' + withdrawal_key).then( response => {
                dispatchWithdrawal({
                    type: "data_fetch_success",
                    payload: response.data
                })   
			}).catch(error => {
                if ((error.response || {}).status === 403) dispatchWithdrawal({type: "data_fetch_failure_403"})
                else if ((error.response || {}).status === 404) dispatchWithdrawal({type: "data_fetch_failure_404"})  
                else dispatchWithdrawal({type: "data_fetch_failure"})    
			})	
		}, 500);
		return () => {
			clearTimeout(timer)
        }
    }, [withdrawal_key])

    if (withdrawal.fetchedData){
        return (
            <div style={{minWidth:"900px", paddingBottom: "30px"}}>
                <div className="analysisCardContainer">
                    <ErrorBoundary>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <div className={["blueText", "titleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                Saque {withdrawal.fetchedData.id}
                            </div>
                            <div className={["labelText", "subtitleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                {moment(withdrawal.fetchedData.withdrawal_date).format("DD/MM/YYYY - HH:mm:ss")}
                            </div>
                        </div>
                    </ErrorBoundary>
                </div>
                <NextTransaction history={history} transaction_key={withdrawal_key} path={"/withdrawal"} suffix={"withdrawal"} page_name={"Saques"}/> 
                <div style={{display: "flex", margin: "10px 0px"}}>
                    <div style={{width: "33%"}}>
                        <div className="analysisCardContainer">
                            <ErrorBoundary>
                                <WithdrawalCard withdrawal={withdrawal.fetchedData}/>
                            </ErrorBoundary>
                        </div>
                        <div className="analysisCardContainer">
                            <ErrorBoundary>
                                <ClientCard withdrawal={withdrawal.fetchedData}/>
                            </ErrorBoundary> 
                        </div>
                    </div>
                    <div style={{width: "66%"}}>
                    <div style={{display:"flex"}}>
                            <div style={{width: "50%"}}>
                                <div className="analysisCardContainer">
                                    <ErrorBoundary>
                                        <DecisionBox 
                                            analysis_events={withdrawal.fetchedData.analysis_events}
                                            analysis_status={withdrawal.fetchedData.analysis_status}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </div>
                            <div style={{width: "50%"}}>
                                <div className="analysisCardContainer" style={{minHeight:"140px"}}>
                                    <ErrorBoundary>
                                        <AlertCard analysis_events={withdrawal.fetchedData.analysis_events}/>
                                    </ErrorBoundary>   
                                </div>
                            </div>
                        </div>
                        <div className="analysisCardContainer" style={{ minHeight: "250px"}}>
                            <ErrorBoundary>
                                <TerminalCard 
                                    withdrawal={withdrawal.fetchedData} 
                                />
                            </ErrorBoundary>
                        </div>
                    </div>
                </div>
                <div className="analysisCardContainer">
                    <ErrorBoundary>
                        <HistoricCard withdrawal={withdrawal.fetchedData}/>
                    </ErrorBoundary>			
                </div>
            </div>
        )
    }
	else if(withdrawal.isError){
		return (
            <div style={{height: "80vh", display:"flex"}}>
                <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                    {withdrawal.errorMessage}
                </p>
            </div>
		)
	}
  
  return null;
}

export default Withdrawal;